import React from 'react';
import GrupoEmpresasTabla from './GrupoEmpresaTable';
import WindowHeader from '../../../commons/WindowHeader';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaArrowsAltH } from '@react-icons/all-files/fa/FaArrowsAltH';

const GrupoEmpresa = (props: any) => {

    const {
        grupoId,
        empresas,
        empresaId,
        seleccionarEmpresa,
        deseleccionarEmpresa,
        canEditGrupoEmpresas,
        filaExpandida = false,
        onToggleFilaExpandida,
    } = props;

    const navigate = useNavigate();

    const addEmpresaHref = grupoId != null && grupoId !== 'new' ? `/empresas/grupo/${grupoId}/empresa/new` : null;

    const editarEmpresa = (empresa: any) => {
        if (grupoId != null && grupoId !== 'new' && empresa?.id != null) {
            navigate(`/empresas/grupo/${grupoId}/empresa/${empresa.id}/edit`);
        }
    };

    const expandFilaButton =
        grupoId != null && grupoId !== 'new' && onToggleFilaExpandida != null ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                title={
                    filaExpandida
                        ? 'Restaurar ancho: mostrar de nuevo proveedores junto a empresas'
                        : 'Expandir empresas al 100 % del ancho (ocultar proveedores en esta fila)'
                }
                aria-label={
                    filaExpandida
                        ? 'Contraer panel de empresas'
                        : 'Expandir panel de empresas a ancho completo'
                }
                onClick={() => onToggleFilaExpandida()}
            >
                <FaArrowsAltH />
            </button>
        ) : null;

    const plusButton =
        addEmpresaHref ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                disabled={!canEditGrupoEmpresas}
                title={canEditGrupoEmpresas ? 'Agregar Empresa' : 'No tiene permiso para agregar empresas'}
                aria-label="Agregar Empresa"
                onClick={() => navigate(addEmpresaHref)}
            >
                <FaPlus />
            </button>
        ) : null;

    const headerActions =
        expandFilaButton != null || plusButton != null ? (
            <div className="d-flex align-items-center gap-1 flex-shrink-0">
                {expandFilaButton}
                {plusButton}
            </div>
        ) : undefined;

    return (
        <div style={{ width: '100%' }}>
            <WindowHeader
                title="Empresas"
                headerExtraRight={headerActions}
            />
            <GrupoEmpresasTabla
                empresaId={empresaId}
                empresas={empresas}
                canEditGrupoEmpresas={canEditGrupoEmpresas}
                onEditarEmpresa={editarEmpresa}
                seleccionarEmpresa={(empresa: any) => { seleccionarEmpresa(empresa); }}
                deseleccionarEmpresa={(empresa: any) => { deseleccionarEmpresa(empresa); }}
            />
        </div>
    );
};

export default GrupoEmpresa;
